import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ButtonModule, DialogModule, InputTextModule, PaginatorModule } from 'primeng';
import { NgIf } from '@angular/common';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  UntypedFormControl,
  Validators,
} from '@angular/forms';
import {
  JobScreenDriverNotesTask,
  JobScreenDriverNotesTaskIndividual,
} from '../../../../../interfaces/screen-specific/job-screen';
import { TaskService } from '../../../../../services';

@Component({
  selector: 'edit-driver-notes-dialog',
  templateUrl: './edit-contact-details-dialog.component.html',
  styleUrls: ['./edit-contact-details-dialog.component.scss'],
  standalone: true,
  imports: [
    DialogModule,
    NgIf,
    InputTextModule,
    PaginatorModule,
    ReactiveFormsModule,
    ButtonModule,
  ],
})
export class EditContactDetailsDialogComponent implements OnInit {
  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {}

  @Input() visible: boolean = false;
  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() selectedTask: JobScreenDriverNotesTask;

  @Input() isPickup: boolean = true;

  get contactType(): string {
    return this.isPickup ? 'Pick-up' : 'Drop-off';
  }

  @Output() onSave = new EventEmitter<JobScreenDriverNotesTaskIndividual>();

  form: FormGroup;
  phone1Error: string;
  phone2Error: string;

  async onShow() {
    this.initForms();
  }
  protected onClose() {
    this.visible = false;
    this.visibleChange.emit(this.visible);
  }

  initForms() {
    this.form = this.fb.group({
      forename: new UntypedFormControl(''),
      surname: new UntypedFormControl(''),
      email: new UntypedFormControl(''),
      secondaryEmail: new UntypedFormControl(null, [Validators.email]),
      phone1: new UntypedFormControl('', (validator: UntypedFormControl) => {
        this.phone1Error = '';

        if (validator.value && !this.validMobileNumber(validator.value)) {
          let error = 'Invalid mobile Number';
          this.phone1Error = error;

          return { valid: false, error: error };
        }

        return null;
      }),

      phone2: new UntypedFormControl('', (validator: UntypedFormControl) => {
        this.phone2Error = '';

        if (validator.value && !this.validPhoneNumber(validator.value)) {
          let error = 'Invalid Phone Number';
          this.phone2Error = error;

          return { valid: false, error: error };
        }

        return null;
      }),
    });

    if (this.isPickup) {
      this.initPickupForm();
    } else {
      this.initDropoffForm();
    }
  }

  initPickupForm() {
    // Ensure the form has the correct values after initialization
    if (this.selectedTask) {
      this.form.patchValue({
        forename: this.selectedTask?.pickupForename ?? '',
        surname: this.selectedTask?.pickupSurname ?? '',
        email: this.selectedTask?.pickupEmail ?? '',
        secondaryEmail: this.selectedTask?.pickupSecondaryEmail ?? null,
        phone1: this.selectedTask?.pickupPhone1 ?? '',
        phone2: this.selectedTask?.pickupPhone2 ?? '',
      });
    }
  }

  initDropoffForm() {
    // Ensure the form has the correct values after initialization
    if (this.selectedTask) {
      this.form.patchValue({
        forename: this.selectedTask?.dropoffForename ?? '',
        surname: this.selectedTask?.dropoffSurname ?? '',
        email: this.selectedTask?.dropoffEmail ?? '',
        secondaryEmail: this.selectedTask?.dropoffSecondaryEmail ?? null,
        phone1: this.selectedTask?.dropoffPhone1 ?? '',
        phone2: this.selectedTask?.dropoffPhone2 ?? '',
      });
    }
  }

  async saveEditDriverNotes() {
    this.onSave.emit(this.form.value);
  }

  validPhoneNumber(phoneNumber: string) {
    return phoneNumber.match(
      /^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?\#(\d{4}|\d{3}))?$/,
    );
  }

  validMobileNumber(phoneNumber: string) {
    return phoneNumber.match(
      /^(((\+44\s?7\d{3}|\(?07\d{3}\)?)\s?\d{3}\s?\d{3})|((\+44\s?7\d{2}|\(?07\d{2}\)?)\s?\d{3}\s?\d{4})|((\+44\s?7\d{1}|\(?07\d{1}\)?)\s?\d{4}\s?\d{4}))?$/,
    );
  }
}
